import { render, staticRenderFns } from "./PinnacleData.vue?vue&type=template&id=494f8f6c&scoped=true&"
import script from "./PinnacleData.vue?vue&type=script&lang=js&"
export * from "./PinnacleData.vue?vue&type=script&lang=js&"
import style0 from "./PinnacleData.vue?vue&type=style&index=0&id=494f8f6c&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "494f8f6c",
  null
  
)

export default component.exports